module.exports = __webpack_public_path__ + "static/media/14.1.b3341c98.png";